import { render, staticRenderFns } from "./ZjgwContent.vue?vue&type=template&id=c48e88ec&scoped=true&"
import script from "./ZjgwContent.vue?vue&type=script&lang=js&"
export * from "./ZjgwContent.vue?vue&type=script&lang=js&"
import style0 from "./ZjgwContent.vue?vue&type=style&index=0&id=c48e88ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e88ec",
  null
  
)

export default component.exports